import { useEffect, useState } from "react";
// import classes from "../../assets/styles/Pages/Help/Tutorial.module.css";
import { Link } from "react-router-dom";
import { get } from "../../server";
import { TUTORIAL } from "../../utils/constants/apiUrl";
import showToast from "../../helpers/showToast";
import { loggedInUser } from "../../utils/store";
import { useAtom } from "jotai";
import Loader from "../../components/Loader";
import tutorial_image from "../../assets/images/help/tutorial_image.png";
import { Button } from "react-bootstrap";

let htmlData = `<h3><strong>1. Initial Device Setup:</strong></h3><p>&nbsp;</p><p><strong>For iPhone Users:</strong></p><ol><li><strong>Setup:</strong>&nbsp;Tap the Contact Co logo to the top of your phone near the speaker or on the back near the cameras.</li><li><strong>Sharing:</strong>&nbsp;Tap the wearable near the top of another iPhone to share your details.</li><li>A notification will appear on your phone. Click on it.</li></ol><p><strong>For Android Users:</strong></p><ol><li><strong>Setup:</strong>&nbsp;Tap the Contact Co logo to the middle-back of your phone.</li><li><strong>Sharing:</strong>&nbsp;Tap the wearable to the middle-back of another Android phone to share your details.</li><li>A notification will pop up. Click on it.</li><li>The notification will direct you to the Apple App Store or the Google Play Store to download our application.</li><li>Open the app and select “Create an Account.” Complete the registration process.</li></ol><h3><strong>2. Profile Setup:</strong></h3><p>&nbsp;</p><ol><li>Upon registration, you’ll be redirected to the profile screen.</li><li>Add your details such as profile picture, phone number, city, country, birthday, gender, and job title.</li><li>Click “Save” or “Skip” if you wish to enter the details later.</li><li>Ensure your phone’s NFC functionality is on (commonly used for Apple Pay or Google Pay) and follow the prompt to link your bracelet.</li></ol><h3><strong>3. Create Your First Function:</strong></h3><p>&nbsp;</p><ol><li>On the Home Screen, click “Create your first function.”</li><li>Navigate to the functions tab.</li><li>With a free package, you can create either 1 personal or 1 business card.</li><li>For paid subscriptions, explore multiple functions like adding various cards, payment services, emergency contacts, URLs, and file uploads.</li><li>Add the required data or skip sections if preferred. All modifications will automatically update on your card.</li></ol><h3><strong>4. Sharing and Networking:</strong></h3><p>&nbsp;</p><ol><li>To activate a function, simply toggle the switch next to it.</li><li>Now, when you tap your device to any phone, it will share the activated function. The recipient doesn’t need the app.</li><li>Save and manage contacts and their cards under the “Connections” tab.</li></ol><h3><strong>5. Navigating the App:</strong></h3><p>&nbsp;</p><ol><li><strong>Home Tab:</strong>&nbsp;View your created functions and have quick access to change device functionality.</li><li><strong>Connections Tab:</strong>&nbsp;A built-in CRM to save and manage your contacts.</li><li><strong>Functions Tab:</strong>&nbsp;Create or view functionalities.</li><li><strong>Shop Tab:</strong>&nbsp;Explore and purchase Contact Co products.</li><li><strong>Scan Tab:</strong>&nbsp;Scan a QR code from another Contact Co user if NFC isn’t available.</li></ol><h3><strong>6. Additional Settings:</strong></h3><p>&nbsp;</p><ol><li>Click the three bars on the top left for further options and settings.<ol><li>Edit your profile, access helpful sections like tutorial videos, FAQs, and more.</li><li>For team account holders, switch between individual and team profiles.</li></ol></li><li>Check app notifications via the bell icon on the top right.</li><li>Adjust subscriptions or explore premium offers through the cash symbol.</li></ol><p>&nbsp;</p><p><strong>Note:</strong>&nbsp;Downgrading your subscription results in all data being wiped from our servers. Upgrading again will require you to re-enter all details.</p><p>If you experience any challenges or have queries, feel free to contact us at&nbsp;<a href="mailto:support@contactco.com">support@contactco.com</a>. We’re here to assist you every step of the way!</p>`;

const Tutorial = () => {
  const [loading, setLoading] = useState(false);
  const [tutorials, setTutorials] = useState([]);

  const [loggedUser] = useAtom(loggedInUser);

  useEffect(() => {
    fetchTutorials();
  }, []);

  const fetchTutorials = async () => {
    setLoading(true);

    let { status, message, data } = await get(
      TUTORIAL,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setTutorials(data);
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  const handleScrollLeft = () => {
    document.getElementById("videoWrapper").scrollLeft -= 300;
  };

  const handleScrollRight = () => {
    document.getElementById("videoWrapper").scrollLeft += 300;
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="helpBackLinkWrapper mb-4">
        <Link to="/help">
          <Button variant="outline-primary">{"<"} Back</Button>
        </Link>
      </div>
      <div className="helpHeader">
        {/* Tutorial top left section */}
        <h3 className="helpHeading">Tutorials</h3>
        <p className="helpSubHeading">
          How to Set Up and Use Your Contact Co Device
        </p>

        <p className="helpDetail">
          Welcome to Contact Co! Our user-friendly devices makes sharing and
          networking a breeze. Here’s a comprehensive guide to help you get
          started
        </p>

        {/*Right Section Image */}
        {/* <div className="col-sm-6">
            <img src={tutorial_image} alt="" className="helpImage" />
          </div> */}
      </div>

      {/* Second Section */}

      {/* <div className={classes.helpbottom}>
        <div className={classes.videoHeader}>
          <span className="">Videos</span>
          <div>
            <FiChevronLeft
              className={classes.videoArrowBtn}
              onClick={handleScrollLeft}
            />
            <FiChevronRight
              className={classes.videoArrowBtn}
              onClick={handleScrollRight}
            />
          </div>
        </div>
        

        <div className={classes.videoWrapper} id="videoWrapper">
          {tutorials.map((tutorial, index) => (
            <div key={index}>
              <a href={tutorial.url} target="_blank" rel="noreferrer">
                <div className={classes.imageWrapper}>
                  <img
                    src={
                      tutorial.image
                        ? `${baseURL.PUBLIC_URL}${tutorial.image}`
                        : noImage
                    }
                    alt="tutorial"
                    onError={(e) => {
                      e.currentTarget.src = noImage;
                    }}
                  />
                  <BsFillPlayFill />
                </div>
              </a>

              <p className={classes.title}>{tutorial.title}</p>
            </div>
          ))}
        </div>
      </div> */}

      <div className="contentWrapper">
        <p className="detail" dangerouslySetInnerHTML={{ __html: htmlData }} />
      </div>
    </>
  );
};

export default Tutorial;
